export default {
  HAS_NEW_VERSION: "<bold>Đã có bản cập nhật mới</bold><typography>Nhấp để cập nhật Trios</typography>",
  FORCE_UPDATE_CONTENT: "Bạn cần phải cập nhật ứng dụng lên phiên bản mới nhất để sử dụng",
  FINISH_UPGRADE_VERSION: "CẬP NHẬT HOÀN TẤT",
  WHAT_VERSION_NEWS: "CÓ GÌ MỚI TRONG BẢN CẬP NHẬT?",
  RELOAD_PAGE: "Tải lại",
  FORCE_UPDATE_FE_VERSION: "Bạn cần phải tải lại ứng dụng",
};
